import { Injectable } from '@angular/core';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { BehaviorSubject } from 'rxjs';
import { translate, TranslocoService } from '@jsverse/transloco';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private dialogService: DialogService) { }

  private decision = new BehaviorSubject<boolean>(false);
  public decision$ = this.decision.asObservable();

  public updateValue(newValue: any) {
    this.decision.next(newValue);
  }

  public open() {
    const dialogRef = this.dialogService.open({
        title: translate('deleteconfirmation.title'),
        content: translate('deleteconfirmation.description'),
        actions: [
          { text: translate('deleteconfirmation.yes'), value: false },
          { text: translate('deleteconfirmation.no'), value: true }
        ],
        width: '450px',
    });

    dialogRef.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        this.updateValue(false);
      } else {
        if((result.text == "Ja") || (result.text == "Oui")) {
          this.updateValue(true);
        } else {
          this.updateValue(false);
        }
      }
    });
  }
}
